import React from 'react';

const Contact = () => (
    <section className="contact-section" id="c">
        <h2>Contact Us</h2>
        <a className="social-link" href="https://www.google.com/maps/place/Mount+Rainier+Bike+Co-op/@38.9387985,-76.9605424,17z/data=!4m13!1m7!3m6!1s0x89b7c70cabaee009:0x6686ba9d853ad5cb!2s3601+Bunker+Hill+Rd,+Mt+Rainier,+MD+20712!3b1!8m2!3d38.9387985!4d-76.9583537!3m4!1s0x89b7c70cba911ec9:0xb5ed8b3dc9b8f31a!8m2!3d38.9388006!4d-76.958357" target="_blank" rel="noopener noreferrer">3601 Bunker Hill Rd, Mt Rainier MD 20712</a>
        <a className="social-link" href="https://www.facebook.com/mountrainiermdbikecoop" target="_blank" rel="noopener noreferrer">Facebook</a>
        <a className="social-link" href="https://instagram.com/mountrainierbikecoop" target="_blank" rel="noopener noreferrer">Instagram</a>
        <a className="social-link" href="mailto:mountrainiermdbikecoop@gmail.com" target="_blank" rel="noopener noreferrer">Email</a>
        <a className="social-link" href="https://twitter.com/3601bunkerhill" target="_blank" rel="noopener noreferrer">Twitter</a>
    </section>
);

export default Contact;
